<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.agentChecks'),
          $t('text.lineItem') + '：' + $route.query.name,
        ]"
      >
      </breadcrumb>
    </div>
    <narrow :narrows="narrows" @narrowSelect="narrowSelect" />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.tracking"
            :placeholder="$t('delivery.tracking')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.downLoadSearch") }}
            </el-button>

            <el-button
              type="primary"
              size="mini"
              @click="batchVerify"
              :loading="batchVerifyDoing"
            >
              {{ $t("action.selfVerify") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        :row-class-name="rowBgColor"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column
          field="tracking"
          :title="$t('delivery.tracking')"
          min-width="80"
        />
        <vxe-table-column
          field="importCost"
          :title="$t('delivery.importCost')"
          min-width="80"
        />
        <vxe-table-column :title="$t('delivery.deliveryCost')" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.delivery != null">
              {{ row.delivery.deliverCost }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="importWeight"
          :title="$t('delivery.importWeight')"
          min-width="80"
        />
        <vxe-table-column :title="$t('delivery.deliveryWeight')" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.delivery != null">
              {{ row.delivery.weight }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="resultType"
          :title="$t('delivery.resultType')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span
              :class="
                row.resultType == 'fail'
                  ? 'red'
                  : row.resultType == 'warning'
                  ? 'orange'
                  : ''
              "
            >
              {{ $t("resultTypes." + row.resultType) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="result"
          :title="$t('text.explain')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span class="font8">{{ row.result }}</span>
            <!-- <raw-html-limit-number :content="row.result" :number="12" /> -->
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('delivery.serialNo')" min-width="120">
          <template v-slot="{ row }">
            <span v-if="row.delivery != null">
              {{ row.delivery.serialNo }}
              <div class="font8">
                {{ $t("delivery.tracking") }}:{{ row.delivery.tracking }}
              </div>
              <span v-if="row.delivery.settle == true" class="font10 green">
                {{ $t("delivery.settled") }}
              </span>
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column :title="$t('delivery.deliverAt')" min-width="110">
          <template v-slot="{ row }">
            <span v-if="row.delivery != null">
              {{ row.delivery.deliverBy }}
              <div class="font10">{{ row.delivery.deliverAt }}</div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="verifyAt"
          :title="$t('settlement.selfVerifyAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.verifyName }}
            <div class="font10">
              {{ row.verifyAt }}
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import MCourierCostItem from "../../../../api/mCourierCostItem.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      sorter: {
        sortBy: "mCourierCostItem_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("delivery.resultType"),
            items: [
              {
                label: this.$t("resultTypes.fail"),
                key: "fail",
                condition: { resultType: "fail" },
              },
              {
                label: this.$t("resultTypes.warning"),
                key: "warning",
                condition: { resultType: "warning" },
              },
              {
                label: this.$t("resultTypes.success"),
                key: "success",
                condition: { resultType: "success" },
              },
            ],
          },
        ],
      ],
      searchForm: {
        tracking: null,
      },
      //
      batchVerifyDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        mCourierCostId: this.$route.params.id,
      };
    },
  },
  methods: {
    batchVerify() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = self.selectRecords.map((s) => s.id);
      self.batchVerifyDoing = true;
      MCourierCostItem.batchVerify(data).then(function (res) {
        self.batchVerifyDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.selfVerifySuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    download() {
      const self = this;
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      MCourierCostItem.exportExcel(self.combineParams()).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //-----
    dataProvider(params) {
      return MCourierCostItem.search(params);
    },
    // 可选
    checCheckboxMethod({ row }) {
      if (row.resultType == "warning" && row.verifyAt == null) {
        return true;
      }
      return false;
    },

    rowBgColor({ row, rowIndex }) {
      if (row.result.indexOf("核对过")) {
        return "near-bg";
      }

      return "";
    },
  },
};
</script>
